// WorkAbroadHero.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ConsultationModal from '../ConsultationModal';

const WorkAbroadHero = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  return (
    <section className="relative bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* Tag */}
            <span className="inline-block bg-[#F5F8FA] text-[#2542D4] text-sm font-light px-6 py-2 rounded-full mb-6">
              Work Abroad
            </span>

            {/* Heading */}
            <h1 className="text-4xl md:text-5xl font-semibold text-[#202356] mb-6 leading-tight">
              Work Abroad with Verified Employer Pathways
            </h1>

            {/* Subtext */}
            <p className="text-gray-600 text-base font-light leading-relaxed mb-6">
              Working abroad is a serious professional decision that requires preparation, eligibility, and the right connections. We support qualified candidates with access to international job opportunities through verified employer partnerships, structured screening, and interview readiness support.
            </p>

            <p className="text-gray-600 text-base font-light leading-relaxed mb-8">
              We focus on transparency, preparation, and realistic outcomes, ensuring candidates understand each step before proceeding.
            </p>

            {/* CTA Button */}
            <button
              onClick={() => setShowConsultationModal(true)}
              className="inline-block bg-[#202356] hover:bg-[#2d3270] text-white font-normal text-base px-8 py-4 rounded-lg transition-colors"
            >
              Book an Eligibility Consultation
            </button>
          </motion.div>

          {/* Right Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative h-[400px] md:h-[500px] rounded-lg overflow-hidden">
              <img
                src={require('../../assets/work-abroad-hero.jpg')}
                alt="Work Abroad"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal}
        onClose={() => setShowConsultationModal(false)}
        serviceType="work-abroad"
      />
    </section>
  );
};

export default WorkAbroadHero;
